/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_SubtitleInputs */

const en_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade your focus experience!`)
};

const ar_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بترقية تجربة التركيز الخاصة بك!`)
};

const de_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbessern Sie Ihr Fokus-Erlebnis!`)
};

const es_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora tu experiencia de concentración`)
};

const fr_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Améliorez votre expérience de concentration!`)
};

const it_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliora la tua esperienza di concentrazione!`)
};

const ja_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中力を向上させよう！`)
};

const ko_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 경험을 업그레이드하세요!`)
};

const pt_br_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleve o nível da sua experiência de foco!`)
};

const ru_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Улучшите свою сосредоточенность!`)
};

const th_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเกรดประสบการณ์การโฟกัสของคุณ!`)
};

const tr_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma deneyimini yükselt!`)
};

const zh_cn_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全面升级你的专注体验！`)
};

const zh_tw_subscription_exclusive_feature_subtitle = /** @type {(inputs: Subscription_Exclusive_Feature_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全面升級你的專注體驗！`)
};

/**
* | output |
* | --- |
* | "Upgrade your focus experience!" |
*
* @param {Subscription_Exclusive_Feature_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_subtitle = /** @type {((inputs?: Subscription_Exclusive_Feature_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_subtitle(inputs)
	return zh_tw_subscription_exclusive_feature_subtitle(inputs)
});